import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { BlameLogRefType, BlameLogType, } from '@debbie/common/dist/blamelog/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { ErrorYouAreAboutToMakePossibleUnintendedAdjustments, VoucherCategory, } from '@debbie/common/dist/economy/vouchers/index.js';
import { blameLogs } from '@debbie/cortex/dist/api/index.js';
import * as caseVouchersAPI from '@debbie/cortex/dist/api/case-vouchers.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import q from '@debbie/cortex/dist/query.js';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js';
import { ButtonGroup, Button } from '../../index.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { selectRole } from '@debbie/cortex/dist/me/selectors.js';
const CaseVoucherInfoActions = (props) => {
    const lang = useSelector((s) => s.lang);
    const meRole = useSelector(selectRole);
    const tenantId = useSelector(selectTenantId);
    const [loading, setLoading] = useState(false);
    return (React.createElement(React.Fragment, null,
        !props.caseVoucher.deletedAt &&
            (props.caseVoucher.category !== VoucherCategory.TRANSACTION ||
                (meRole && isAdmin(meRole))) && (React.createElement(Button, { theme: "dangerous", size: "mini", loading: loading, disabled: false, onClick: async () => {
                setLoading(true);
                try {
                    const del = (preventAdjustments) => caseVouchersAPI.delCaseVoucher(props.caseVoucher.caseVoucherId, {
                        preventAdjustments: preventAdjustments,
                    });
                    try {
                        await del(true);
                    }
                    catch (error) {
                        if (
                        // @ts-ignore
                        error?.message?.indexOf(ErrorYouAreAboutToMakePossibleUnintendedAdjustments) !== -1) {
                            if (confirm(lang.billing.warnThisWillAffectBilling)) {
                                await del(false);
                            }
                        }
                        else {
                            throw error;
                        }
                    }
                    if (props.caseVoucher.caseId) {
                        const blameLog = {
                            details: props.caseVoucher,
                            refId: props.caseVoucher.caseId,
                            refType: BlameLogRefType.Case,
                            type: BlameLogType.CaseVoucherDelete,
                        };
                        if (tenantId)
                            await blameLogs.createBlameLog(blameLog, tenantId);
                    }
                    q.invalidate(keys.write.modify(caseVouchersEntity, props.caseVoucher.caseVoucherId));
                }
                catch (err) {
                    console.error(err);
                    alert('Error');
                }
                props.onDeleteVoucher && props.onDeleteVoucher();
                setLoading(false);
            } }, lang.economy.voucherInfoDeleteVoucher)),
        React.createElement(ButtonGroup, { style: { float: 'right' } },
            props.caseVoucher.category !== VoucherCategory.TRANSACTION &&
                !(props.caseVoucher.expired || props.caseVoucher.irrecoverableDate) && (React.createElement(Button, { size: "mini", loading: loading, onClick: async () => {
                    setLoading(true);
                    try {
                        if (props.caseVoucher.caseId && tenantId) {
                            await caseVouchersAPI.patchCaseVoucher(props.caseVoucher.caseVoucherId, {
                                caseId: props.caseVoucher.caseId,
                                irrecoverableDate: moment().format(),
                            });
                            q.invalidate(keys.write.modify(caseVouchersEntity, props.caseVoucher.caseVoucherId));
                            const blameLog = {
                                details: props.caseVoucher,
                                refId: props.caseVoucher.caseId,
                                refType: BlameLogRefType.Case,
                                type: BlameLogType.CaseVoucherIrrecoverable,
                            };
                            await blameLogs.createBlameLog(blameLog, tenantId);
                        }
                    }
                    catch (err) {
                        alert('Error');
                    }
                    setLoading(false);
                } }, lang.economy.voucherInfoMarkVoucherIrrecoverable)),
            props.caseVoucher.category !== VoucherCategory.TRANSACTION && (React.createElement(Button, { size: "mini", loading: loading, onClick: async () => {
                    setLoading(true);
                    try {
                        if (props.caseVoucher.caseId && tenantId) {
                            await caseVouchersAPI.patchCaseVoucher(props.caseVoucher.caseVoucherId, {
                                caseId: props.caseVoucher.caseId,
                                expired: !props.caseVoucher.expired,
                            });
                            q.invalidate(keys.write.modify(caseVouchersEntity, props.caseVoucher.caseVoucherId));
                            const blameLog = {
                                details: props.caseVoucher,
                                refId: props.caseVoucher.caseId,
                                refType: BlameLogRefType.Case,
                                type: BlameLogType.CaseVoucherExpired,
                            };
                            await blameLogs.createBlameLog(blameLog, tenantId);
                        }
                    }
                    catch (err) {
                        alert('Error');
                    }
                    setLoading(false);
                } }, props.caseVoucher.expired
                ? lang.economy.voucherInfoUnmarkVoucherExpired
                : lang.economy.voucherInfoMarkVoucherExpired)))));
};
export default CaseVoucherInfoActions;
//# sourceMappingURL=CaseVoucherInfoActions.js.map